import { useDispatch } from 'react-redux';
import io from 'socket.io-client';
import toast from '../../components/templates/ToastMessage';
import { ADMIN_SUPPORT, ADMIN_SUPPORT_STATUS, getAdminDetails, getToken, INIT_ADMIN_SUPPORT } from '../asyncConfig';
import { updateSocketID } from '../auth/auth_thunk';
import { setSupportIssues } from './support_slice';

export function useSocket() {
  const SOCKET_URL = process.env.REACT_APP_WAYRIDE_SOCKET_URL;
  // const SOCKET_URL = 'ws://localhost:4000';
  const dispatch = useDispatch();
  let socket;

  const initializeSockets = () => {
    socket = io.connect(SOCKET_URL, {
      extraHeaders: { 'Authorization': `Bearer ${getToken()}` }
    });
    socket.on('connect', () => {
      const admin = getAdminDetails();
      console.log('connected', socket.id);
      dispatch(updateSocketID({ id: admin.id, socket_id: socket.id }));
      socket.emit(INIT_ADMIN_SUPPORT);
      socket.on(ADMIN_SUPPORT_STATUS, ({ success }) => {
        if (success) {
          socket.emit(INIT_ADMIN_SUPPORT);
        }
      })
      socket.on(ADMIN_SUPPORT, (data) => {
        if (data.success) {
          console.log('data issues:: ', data);
          dispatch(setSupportIssues(data.issues))
        } else {
          toast({ message: data.message, status: 'fail' })
        }
        console.log(ADMIN_SUPPORT, data,);
      })
    });
  }

  const updateIssueStatus = (status, id) => {
    if (!socket) initializeSockets();
    socket.emit(ADMIN_SUPPORT_STATUS, { status, id });
  }

  const replyIssueMessage = (message, issue_id) => {
    if (!socket) initializeSockets();
    console.log('sending....', message, issue_id, socket);
    socket.emit(ADMIN_SUPPORT, { message, issue_id });
  }

  return {
    initializeSockets,
    replyIssueMessage,
    updateIssueStatus
  }
}